import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(value).format("DD/MM/YYYY");
  }
});

Vue.filter("formatSpeed", function (value) {
  if (value) {
    return value.toFixed(1) + " Km/h";
  }
});

Vue.filter("formatHour", function (value) {
  if (value) {
    return moment(value).format("DD/MM/YYYY - HH:mm");
  }
});

Vue.filter("formatSeconds", function (value) {
  if (value) {
    return moment(value).format("HH:mm:ss");
  }
});
